import React from 'react'
import { Select } from 'antd'

const CustomSelectField = ({ 
  placeholder = "Select options...", 
  options = [], 
  value = [], 
  onChange, 
  className = "",
  searchable = true,
  disabled = false,
  showDropdown = true
}) => {
  return (
    <Select
      mode="multiple"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      options={options}
      className={`w-full ${className}`}
      showSearch={searchable}
      disabled={disabled}
      open={showDropdown ? undefined : false}
      style={{
        minHeight: '40px'
      }}
      tagRender={(props) => {
        const { label, closable, onClose } = props
        return (
          <span
            className="inline-flex items-center gap-1 px-3 py-1 bg-orange-100 text-orange-700 rounded-md text-sm font-medium mr-1 mb-1"
          >
            <span>{label}</span>
            {closable && (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation()
                  onClose()
                }}
                className="hover:bg-orange-200 rounded-full p-0.5 transition-colors ml-1"
              >
                ×
              </button>
            )}
          </span>
        )
      }}
      dropdownStyle={{
        background: 'white',
        border: '1px solid #d1d5db',
        borderRadius: '8px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
      }}
    />
  )
}

export default CustomSelectField